exports.slugToTitle = (slug) => {
  // Replace all '-' with ' '
  let title = slug?.replace(/-/g, " ");

  // Capitalize first letter of each word
  title = title?.replace(/\b\w/g, (match) => match.toUpperCase());

  return title;
};
